
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartLayers as ObiChartLayersElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-layers.js';
 
 
 

 
 export const ObiChartLayers = createComponent({
   react: React,
   tagName: 'obi-chart-layers',
   elementClass: ObiChartLayersElement,
   events: {
     
   }
  });
 
 